


// TODO - remove Backbone Event extension
export default class Timer {
  constructor(milliseconds = 1000, numTicks = 1){
    this.millisecondsOffset = 0;
    this.milliseconds = milliseconds;
    this.currentTick = 0;
    this.numTicks = numTicks;
    this.handleInterval = this.handleInterval.bind(this);
  }

  get isDone(){
    return this.currentTick >= this.numTicks;
  }

  get isRunning(){
    return Boolean(this.intervalId);
  }

  start(){
    let newDelay = this.millisecondsOffset + this.milliseconds;

    if(!this.isRunning && !this.isDone && newDelay > 0) {
      this.startTime = Date.now();
      this.intervalId = setInterval(this.handleInterval, newDelay);
    }
  }

  pause(){
    if(this.isRunning) {
      clearInterval(this.intervalId);
      this.intervalId = 0;
      this.millisecondsOffset = this.startTime - Date.now();
    }
  }

  stop(){
    this.pause();
    this.currentTick = 0;
    this.millisecondsOffset = 0;
  }

  restart(){
    this.stop();
    this.start();
  }

  handleInterval(){
    this.startTime = Date.now();
    this.currentTick++;
    this.trigger(Timer.TICK);

    if(this.isDone){
      this.pause();
      this.trigger(Timer.COMPLETE);
    }
  }
}

Timer.TICK = "TICK";
Timer.COMPLETE = "COMPLETE";

_.extend(Timer.prototype, Backbone.Events);



// WEBPACK FOOTER //
// ./assets/es6/common/timer.es6